<script setup>
import { ref, computed, onMounted, getCurrentInstance } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const { proxy } = getCurrentInstance();
const swal = proxy.$swal

// State
const page = ref(1)
const perPage = ref(10)
const expandedItems = ref({})
const showReply = ref(false)
const replyContent = ref('')
const selectedInquiryId = ref(null)
const isSubmitting = ref(false)

// Computed
const list = computed(() => proxy.$store.state.inquiries)
const totalCount = computed(() => proxy.$store.state.inquiriesTotal)

// Methods
const getList = async () => {
  await proxy.$store.dispatch('fetchInquiries', {
    page: page.value,
    perPage: perPage.value,
  })
}

const refineContent = (content) => {
  return content.replace('\\n', '<br>')
}

const truncateContent = (content, length) => {
  if (content.length <= length) return content
  return content.substring(0, length) + '...'
}

const toggleContent = (index) => {
  expandedItems.value[index] = !expandedItems.value[index]
}

const showReplyForm = (inquiryId) => {
  selectedInquiryId.value = inquiryId
  showReply.value = true
  replyContent.value = ''
}

const closeReplyForm = () => {
  showReply.value = false
  selectedInquiryId.value = null
  replyContent.value = ''
}

const submitReply = async () => {
  if (!replyContent.value.trim()) return
  
  isSubmitting.value = true
  
  // TODO: 기능추가
  // try {
  //   const response = await axios.post('/api/inquiry/reply', {
  //     id: selectedInquiryId.value,
  //     answer: replyContent.value
  //   })
    
  //   if (response.data.success === 'true') {
  //     swal.success(response.data.message)
  //     closeReplyForm()
  //     fetchInquiries()
  //   } else {
  //     swal.info(response.data.message)
  //   }
  // } catch (error) {
  //   swal.error(error.response?.data?.message || t('common.error'))
  // } finally {
  //   isSubmitting.value = false
  // }
}

const deleteInquiry = async (inquiryId) => {
  try {
    proxy.$swal.confirm(t('inquiry.deleteConfirmation')).then(async (result) => {
      if (result.isConfirmed) {
        proxy.$store.dispatch('deleteInquiry', {
          id: inquiryId
        })
        getList()
      }
    })
  } catch (error) {
    swal.error(error.response?.data?.message || t('common.error'))
  }
}

const viewInquiry = async () => {
  try {
    // TODO: 기능추가
    // await axios.get(`${proxy.api_inquries}/${inquiryId}`)
    // const inquiry = list.value.find(item => item.id === inquiryId)
    // if (inquiry) {
    //   inquiry.status = userId.value.toString()
    // }
  } catch (error) {
    console.error('Failed to update inquiry view:', error)
  }
}

const handlePageChange = (page) => {
  page.value = page
  getList()
}

// Lifecycle
onMounted(() => {
  getList()
})
</script>

<template>
  <div class="chatlist_tata">
    <!-- <h6 class="flex justify-center items-center pb-2">
      <i class="fab fa-telegram-plane mr-1" style="font-size: 24px; color: #229ED9;"></i>
      <a href="https://t.me/+zMwnZzUHQCBhYzc1" target="_blank">https://t.me/+zMwnZzUHQCBhYzc1</a>
    </h6> -->
    <table class="table table-bordered">
      <thead>
        <tr>
          <th scope="col">{{ t('inquiry.question') }}</th>
          <th scope="col">{{ t('inquiry.answer') }}</th>
          <th scope="col">{{ t('inquiry.status') }}</th>
        </tr>
      </thead>
      <tbody v-if="list.length > 0">
        <tr v-for="(inquiry, index) in list" :key="inquiry.id">
          <td style="width: 35%">
            <p class="text-gray-500 mb-0">
              {{ new Date(inquiry.created_at).toLocaleString() }}
            </p>
            <p class="font-bold my-2">{{ t(inquiry.title) }}</p>
            
            <div class="inquiry-content">
              <div
                v-if="!expandedItems[index]"
                v-html="truncateContent(refineContent(inquiry.content), 200)"
              />
              <div v-else v-html="refineContent(inquiry.content)"></div>
              <button 
                v-if="inquiry.content.length > 200"
                class="text-link mt-2"
                @click="toggleContent(index)"
              >
                {{ expandedItems[index] ? t('common.showLess') : t('common.showMore') }}
              </button>
            </div>
          </td>
          
          <td style="width: 50%">
            <template v-if="inquiry.user_send === 1">
              <div v-if="!inquiry.answer" class="text-center">
                <button 
                  class="reply-btn"
                  @click="showReplyForm(inquiry.id)"
                >
                  <img src="@/assets/img/etc/rep.png" alt="Reply" />
                </button>
              </div>
              <div v-else class="answer-content">
                <div
                  v-if="!expandedItems[index]"
                  v-html="truncateContent(refineContent(inquiry.answer), 300)"
                />
                <div v-else v-html="refineContent(inquiry.answer)"></div>
                
                <button 
                  v-if="inquiry.answer.length > 300"
                  class="text-link mt-2"
                  @click="toggleContent(index)"
                >
                  {{ expandedItems[index] ? t('common.showLess') : t('common.showMore') }}
                </button>
              </div>
            </template>
            
            <template v-else>
              <div v-if="!inquiry.answer" class="pending-notice">
                {{ t('inquiry.pending') }}
                <button 
                  class="delete-btn ml-2"
                  @click="deleteInquiry(inquiry.id)"
                >
                  <i class="fas fa-trash-alt delete-icon"></i>
                </button>
              </div>
              <div v-else class="answer-content">
                <div class="title-notify" @click="viewInquiry(inquiry.id)">
                  <div v-html="truncateContent(inquiry.answer, 200)"></div>
                </div>
                <button 
                  class="delete-btn ml-2"
                  @click="deleteInquiry(inquiry.id)"
                >
                  <i class="fas fa-trash-alt delete-icon"></i>
                </button>
              </div>
            </template>
          </td>
          
          <td style="width: 15%" class="text-center">
            {{ inquiry.status === 'PENDING'
              ? t('inquiry.pending')
              : inquiry.status === 'IN_PROGRESS'
                ? t('inquiry.inProgress')
                : inquiry.status === 'COMPLETED'
                  ? t('inquiry.completed')
                  : t('inquiry.unknown')
            }}
          </td>
        </tr>
      </tbody>
      
      <tbody v-else>
        <tr>
          <td colspan="3" class="text-center">{{ t('common.noData') }}</td>
        </tr>
      </tbody>
    </table>
    <nav class="custom-pagination not-center">
      <paginate
        @update:modelValue="handlePageChange"
        :total-count="totalCount"
        :limit="perPage"
        v-model="page"
      />
    </nav>

    <!-- Reply Modal -->
    <div v-if="showReply" class="modal-overlay">
      <div class="modal-content">
        <div class="modal-header">
          <h3>{{ t('inquiry.reply') }}</h3>
          <button class="close-btn" @click="closeReplyForm">&times;</button>
        </div>
        
        <form @submit.prevent="submitReply">
          <textarea
            v-model="replyContent"
            rows="6"
            class="reply-textarea"
            :placeholder="t('inquiry.replyPlaceholder')"
          ></textarea>
          
          <div class="modal-footer">
            <button 
              type="submit"
              class="btn btn-primary"
              :disabled="isSubmitting"
            >
              {{ t('common.send') }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  padding: 1.5rem;
  border-radius: 8px;
  width: 90%;
  max-width: 600px;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.close-btn {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
}

.reply-textarea {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  resize: vertical;
  min-height: 150px;
  margin-bottom: 1rem;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
}

.text-link {
  color: #007bff;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
}

.text-link:hover {
  text-decoration: underline;
}

.reply-btn,
.delete-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.25rem;
}

.reply-btn img,
.delete-btn img {
  width: 20px;
  height: 20px;
}

.pending-notice {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;
}

.inquiry-content,
.answer-content {
  line-height: 1.6;
}

@media (max-width: 768px) {
  .sm-col {
    flex-direction: column;
    gap: 1rem;
  }
  
  .modal-content {
    width: 95%;
    margin: 1rem;
  }
}

.delete-icon {
  color: rgb(215, 0, 6);
}
</style>
